import { AuthGuard } from "../../auth/helpers";
import { FormJobPositionsComponent } from "./pages/form/form-job-positions.component";
import { JobPositionsListComponent } from "./pages/list/job-positions-list.component";
import { JobCategoriesListComponent } from "./pages/job-categories-list/job-categories-list.component";
import { ViewJobPositionsComponent } from "./pages/view/view-job-positions.component";
import { CandidatureListComponent } from "./pages/candidature-list/candidature-list.component";
import { IRoute } from "app/auth/models/utils-interfaces";

const jobPositionsRoutes: IRoute[] = [
  {
    path: "dashboard/job-positions",
    component: JobPositionsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/job-positions/edit/:slug",
    canActivate: [AuthGuard],
    component: FormJobPositionsComponent,
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/job-positions/view/:id",
    canActivate: [AuthGuard],
    component: ViewJobPositionsComponent,
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/job-positions/add",
    canActivate: [AuthGuard],
    component: FormJobPositionsComponent,
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/job-positions-categories",
    component: JobCategoriesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/job-positions-candidature",
    component: CandidatureListComponent,
    canActivate: [AuthGuard],
  },
];

export default jobPositionsRoutes;
